import { render, staticRenderFns } from "./GhostButtons.vue?vue&type=template&id=393672ca"
import script from "./GhostButtons.vue?vue&type=script&lang=js"
export * from "./GhostButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports